import React from "react";
import {
  Box,
  CardContent,
  CardMedia,
  Typography,
  Tooltip,
} from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import ImageIcon from "@mui/icons-material/Image";
import moment from "moment";
import {
  StyledCard,
  StyledIconButton,
  CardHeader,
  ImageContainer,
} from "./StyledComponents";

const RecipeImage = ({ recipe, onImageUpload }) => {
  if (!recipe) {
    return null;
  }

  // Construct URL with timestamp to prevent caching issues
  const url =
    recipe.imageUrl && recipe.updatedOn
      ? `${recipe.imageUrl}&${moment(recipe.updatedOn.toDate()).toISOString()}`
      : recipe.imageUrl;

  return (
    <StyledCard sx={{ ml: 3, height: "auto" }}>
      <CardHeader>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ImageIcon color="primary" sx={{ fontSize: 20, mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            Recipe Image
          </Typography>
        </Box>
      </CardHeader>
      <CardContent sx={{ p: 0, position: "relative" }}>
        <ImageContainer>
          {recipe.imageUrl ? (
            <CardMedia
              component="img"
              height="360"
              image={url}
              alt={recipe.name}
              sx={{ objectFit: "cover" }}
            />
          ) : (
            <Box
              sx={{
                height: 360,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "grey.100",
                color: "grey.500",
                flexDirection: "column",
              }}
            >
              <ImageIcon sx={{ fontSize: 60, opacity: 0.5, mb: 2 }} />
              <Typography variant="body1" color="text.secondary">
                No image available
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Click the camera icon to upload
              </Typography>
            </Box>
          )}

          <Tooltip title="Upload Image">
            <StyledIconButton component="label">
              <AddAPhotoIcon />
              <input
                hidden
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={onImageUpload}
              />
            </StyledIconButton>
          </Tooltip>
        </ImageContainer>
      </CardContent>
    </StyledCard>
  );
};

export default RecipeImage;
